import { Button } from 'antd';
import saveAs from 'file-saver';
import { Attachments } from '../../Inbound/Interface';

function DownloadAttachment({ label, typeButton, data }: any) {
  const download = () => {
    data?.map((attachment: Attachments) => {
      saveAs(attachment.url, attachment.fileName);
    });
  };
  return (
    <div className="attachDown">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <p>{label}</p>
        <Button type="primary" onClick={download}>{`${typeButton}`}</Button>
      </div>
      <div
        style={{
          height: '60px',
          overflowY: 'auto'
        }}
      >
        {data?.map((attchment: Attachments, index: number) => (
          <p key={index}>{attchment.fileName}</p>
        ))}
      </div>
    </div>
  );
}

export default DownloadAttachment;
